// Action Types
export const FETCH_FEATURE_FLAGS = 'launchDarkly/fetch-feature-flags';

// Actions
export const fetchFeatureFlags = (flags) => ({
    type: FETCH_FEATURE_FLAGS,
    payload: flags,
});